import { Module, UserRole } from '@hobt/constants';
import { UserInfo } from '@hobt/user-domain';

export type ArrearsUser = {
  roles: UserRole[];
};

const defaultValue: ArrearsUser = { roles: [] };

const fromUserInfo = (userInfo: UserInfo): ArrearsUser => {
  const roles = userInfo.moduleRoleMapping[Module.Arrears] ?? [];
  return { roles };
};

// eslint-disable-next-line no-redeclare
export const ArrearsUser = {
  defaultValue,
  fromUserInfo
} as const;
